export default __webpack_public_path__ + "static/media/cloud_left.246431d6.png";